import { render, staticRenderFns } from "./Datamodify.vue?vue&type=template&id=6fe70644&scoped=true"
import script from "./Datamodify.vue?vue&type=script&lang=js"
export * from "./Datamodify.vue?vue&type=script&lang=js"
import style0 from "./Datamodify.vue?vue&type=style&index=0&id=6fe70644&prod&scoped=true&lang=css"
import style1 from "./Datamodify.vue?vue&type=style&index=1&id=6fe70644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe70644",
  null
  
)

export default component.exports